import { connect } from 'react-redux'
import MobilityDevicesList from '../../components/global-settings/MobilityDevicesList'
import { IStoreState } from '../../types/index'
import { getMobilityOptions, getMobilityOptionCategories } from 'src/state/actions/mobility-options'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    devices: state.mobilityOptions.items,
    categories: state.mobilityOptionsCategories.items
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    getMobilityOptions: () => {
      dispatch(getMobilityOptions())
    },
    getMobilityOptionCategories: () => {
      dispatch(getMobilityOptionCategories())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MobilityDevicesList)



// WEBPACK FOOTER //
// ./src/containers/global-settings/MobilityDevicesList.ts